module.exports = __webpack_public_path__ + "static/img/recharge_success.04a1a71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recharge_success.png
// module id = TiWk
// module chunks = 0